/* eslint-disable @typescript-eslint/no-unused-vars */
import { isEmpty, isNil, groupBy } from 'lodash';

const IGNORE_FIELD = [
  'bookQuantity',
  'requestProduced',
  'producedPercentage',
  'requestPacked',
  'packedPercentage',
  // SECTION3,
  'numberOfDefect',
  // SECTION 5
  'dim',
  'actualNetWeight',
  'actualGrossWeight',
  'totalQuantity',
  'outerQuantity',
  'outerCarton',
  'barcode',
  'actualBarcode'
];

export const isFieldRequired = (
  sectionName: string | number,
  field: { type: string; name: any; optional: any }
) => {
  const SECTION_FIELDS: any = {
    quantityAvailable: [
      'producedQuantity',
      'packedQuantity',
      'referenceMedia',
      'result',
      'remark'
    ],
    productDescriptionStyleColor: [
      'signedSampleAvailable',
      'appearance',
      'accessories',
      'material',
      'package',
      'labelling',
      'referenceMedia',
      'remark',
      'result'
    ],
    workmanship: ['signedSampleAvailable', 'defects', 'remark'],
    packingMarking: [
      'sellingUnitContent',
      'innerPackContent',
      'outerCartonContent',
      'remark'
    ],
    onSiteTest: ['checkList'],
    importantRemarksAttachments: ['remark', 'attachments'],
    sellingUnitContent: [
      'length',
      'width',
      'height',
      // 'actualBarcode',
      // 'actualNetWeight',
      // 'actualGrossWeight',
      'result',
      'remark'
      // 'referenceMedia'
    ],
    innerPackContent: [
      'length',
      'width',
      'height',
      // 'actualBarcode',
      // 'actualNetWeight',
      // 'actualGrossWeight',
      'result',
      'remark'
      // 'referenceMedia'
    ],
    outerCartonContent: [
      'length',
      'width',
      'height',
      // 'actualBarcode',
      // 'actualNetWeight',
      // 'actualGrossWeight',
      'result',
      'remark'
      // 'referenceMedia'
    ]
  };
  const section = SECTION_FIELDS[sectionName] || [];
  if (field.type === 'LIST') {
    return true; // default always required
  }

  return section.includes(field.name) && isEmpty(field.optional);
};

const isRequiredField = (field: any, sectionName: any, attachments: any[]) => {
  const isRequired = IGNORE_FIELD.includes(field.name)
    ? false
    : !field.optional;
  let isCompleted = false;
  const isUploadField = field.type === 'UPLOAD' || field.type === 'ATTACHMENT';
  const value = isUploadField
    ? (field.value || [])
        .map((fileId: any) => {
          const file = (attachments || []).find(({ id }) => id === fileId);
          return file || null;
        })
        .filter((file: any) => !!file)
    : field.value || field.defaultValue;

  if (isRequired) {
    if (!isEmpty(value)) {
      isCompleted = true;
    }
  }
  return { isRequired, isCompleted, value };
};

const getFieldValue = (field: any, attachments: any[]) => {
  const isUploadField = field.type === 'UPLOAD' || field.type === 'ATTACHMENT';
  if (isUploadField) {
    if (field.name === 'referenceFile') {
      return field.value || field.defaultValue || [];
    }
    return (field.value || [])
      .map((fileId: string) => {
        const file = (attachments || []).find(({ id }) => id === fileId);
        return file || null;
      })
      .filter((file: any) => !!file);
  }
  const fieldValue = isUploadField
    ? (field.value || [])
        .map((fileId: string) => {
          const file = (attachments || []).find(({ id }) => id === fileId);
          return file || null;
        })
        .filter((file: any) => !!file)
    : field.value || field.defaultValue || '';
  return fieldValue;
};

const getRequiredFieldListByKeys = (
  fields: any[],
  attachments: any[],
  key: string[] = []
) => {
  const required: any[] = [];
  const completed: any[] = [];
  const values: any[] = [];
  fields.forEach((item) => {
    // Default is required;
    const requiredFields = [];
    const completedFields = [];
    let itemValue = {};
    item.forEach((itemField: any) => {
      const fieldValue = getFieldValue(itemField, attachments);
      itemValue = {
        ...itemValue,
        [itemField.name]: fieldValue
      };
      const { optional = false } = itemField;
      if (key.length) {
        if (!optional && key.includes(itemField.name)) {
          requiredFields.push(itemField);
          if (itemField.value) {
            completedFields.push(itemField);
          }
        }
        return;
      }
      if (!optional) {
        requiredFields.push(itemField);
        if (itemField.value) {
          completedFields.push(itemField);
        }
      }
    });
    if (requiredFields.length) {
      required.push(item);
    }
    if (requiredFields.length === completedFields.length) {
      completed.push(itemValue);
    }
    values.push(itemValue);
  });
  return {
    required,
    completed,
    values
  };
};

const getRequiredFieldsBySection = (
  section: any,
  fields: any[],
  attachments: any[]
) => {
  switch (section.name) {
    case 'workmanship': {
      return fields.reduce(
        (acc, field) => {
          if (field.type === 'LIST') {
            const {
              required: requiredFields,
              completed: completedFields,
              values
            } = getRequiredFieldListByKeys(
              field.items || field.fields,
              attachments,
              ['quantity']
            );
            // const items = field.items || field.fields;
            acc.required = acc.required.concat(requiredFields);
            acc.completed = acc.completed.concat(completedFields);
            acc.value = {
              ...acc.value,
              [field.name]: values
            };
          } else {
            const { isRequired, isCompleted } = isRequiredField(
              field,
              section.name,
              attachments
            );
            if (isRequired) {
              acc.required.push(field);
            }
            if (isRequired && isCompleted) {
              acc.completed.push(field);
            }
            acc.value = {
              ...acc.value,
              [field.name]: field.value || field.defaultValue
            };
          }

          return {
            ...acc
          };
        },
        {
          required: [],
          completed: [],
          value: {}
        }
      );
    }

    case 'onSiteTest':
      return fields.reduce(
        (acc, field) => {
          if (field.type === 'LIST') {
            const {
              required: requiredFields,
              completed: completedFields,
              values
            } = getRequiredFieldListByKeys(
              field.items || field.fields,
              attachments
            );
            // const items = field.items || field.fields;
            acc.required = acc.required.concat(requiredFields);
            acc.completed = acc.completed.concat(completedFields);
            acc.value = {
              ...acc.value,
              [field.name]: values
            };
          } else {
            acc.value = {
              ...acc.value,
              [field.name]: field.value || field.defaultValue
            };
          }
          return {
            ...acc
          };
        },
        {
          required: [],
          completed: [],
          value: {}
        }
      );
    case 'packingMarking':
      return fields.reduce(
        (acc, field) => {
          if (field.type === 'SECTION') {
            const {
              value: sectionValue,
              required: sectionRequiredFields,
              completed: sectionCompletedFields
            } = getRequiredFieldsBySection(field, field.fields, attachments);

            if (sectionRequiredFields.length) {
              acc.required = acc.required.concat(field);
            }
            if (
              sectionRequiredFields.length === sectionCompletedFields.length
            ) {
              acc.completed = acc.completed.concat(field);
            }

            acc.value = {
              ...acc.value,
              [field.name]: sectionValue
            };
          }

          return {
            ...acc
          };
        },
        {
          required: [],
          completed: [],
          value: {}
        }
      );
    default:
      return fields.reduce(
        (acc, field) => {
          const { isRequired, isCompleted, value } = isRequiredField(
            field,
            section.name,
            attachments
          );
          if (isRequired) {
            acc.required.push(field);
          }
          if (isRequired && isCompleted) {
            acc.completed.push(field);
          }
          acc.value = {
            ...acc.value,
            [field.name]: value || field.defaultValue
          };
          return {
            ...acc
          };
        },
        {
          required: [],
          completed: [],
          value: {}
        }
      );
  }
};

export const getRequiredCompletedFields = (
  section: any,
  attachments: any[]
) => {
  const { fields } = section || {};
  const { required, completed, value } = getRequiredFieldsBySection(
    section,
    fields,
    attachments
  );
  return { value, requiredFields: required, completedFields: completed };
};

export const COMPUTING_STATUS_REPORT_SECTION: any = {
  quantityAvailable: (
    sectionValues: { result: any },
    _requiredFields: any,
    _completedFields: any
  ) => {
    return sectionValues.result || 'pending';
  },
  productDescriptionStyleColor: (
    sectionValues: { result: any },
    _requiredFields: any,
    _completedFields: any
  ) => {
    return sectionValues.result || 'pending';
  },
  workmanship: (
    sectionValues: { defects: any },
    requiredFields: any,
    completedFields: any,
    { poItem }: any
  ) => {
    // Will Compute status base on the request AQL
    const { defects } = sectionValues;
    const { aql } = poItem;
    const groupByClassification = groupBy(
      defects || [],
      'defectClassification'
    );
    const total = Object.keys(groupByClassification).reduce(
      (acc: any, key) => {
        groupByClassification[key].forEach((defect) => {
          const { quantity } = defect;
          if (!isEmpty(quantity)) {
            acc[key] += parseInt(quantity);
          }
        });
        return acc;
      },
      { critical: 0, minor: 0, major: 0 }
    );
    const results = Object.keys(total).map((classification) => {
      return total[classification] > aql[classification] ? 'failed' : 'passed';
    });
    const isRejected = results.some((result) => result === 'failed');

    if (isRejected) return 'failed';
    return 'passed';
  },
  onSiteTest: (
    sectionValues: { checkList: any[]; result: string } & Record<string, any>,
    _requiredFields: any,
    _completedFields: any
  ) => {
    const { checkList } = sectionValues;
    const isPending = checkList.some(({ result }) => isEmpty(result));
    const isPassed = checkList.every(({ result }) => result === 'passed');
    if (isPending) return 'pending';
    if (isPassed) return 'passed';
    return 'failed';
  },
  packingMarking: (
    values: { [x: string]: { result: any } },
    _requiredFields: any,
    _completedFields: any
  ) => {
    const results = Object.keys(values).map((key) => {
      const { result } = values[key];
      if (isEmpty(result)) return 'pending';
      return result;
    });
    const isPending = results.some((result) => result === 'pending');
    const isPassed = results.every((result) => result === 'passed');
    if (isPending) return 'pending';
    if (isPassed) return 'passed';
    return 'failed';
  },
  importantRemarksAttachments: (
    _values: any,
    requiredFields: string | any[],
    completedFields: string | any[]
  ) => {
    return requiredFields.length === completedFields.length
      ? 'passed'
      : 'pending';
  }
};

export const parserReportTemplate = (template: any) => {
  if (isNil(template)) return [];
  const jsonParsed = JSON.parse(template);
  const sections = Array.from(jsonParsed);
  if (!sections.length) return [];
  const parsedSections = sections.filter((section: any) => !!section.enabled);
  return parsedSections.reduce((acc: any, section: any) => {
    if (['onSiteTest', 'packingMarking'].includes(section.name)) {
      const fields = section.fields.filter((field: any) => {
        const { enabled = true } = field;
        return enabled;
      });
      acc.push({
        ...section,
        fields
      });
      return acc;
    }

    acc.push({ ...section });
    return acc;
  }, []);
};
